import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import throttle from '../../../../util/throttle';

import { handleError, saveConfig, updateTrials, updateEndDate, updateStartDate } from '../../FilterActions';

// Import Style
import './MonteCarloDeliveryControls.scss';

class MonteCarloTasksControls extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.saveChanges = throttle(this._saveChanges, 1000, this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.trials !== this.props.trials ||
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      this.updateState();
    }
  }

  updateState() {
    this.setState({
      trials: this.props.trials,
      startDate: moment(this.props.startDate),
      endDate: moment(this.props.endDate),
    });
  }

  _saveChanges = (name, value) => {
    const isNumber = !!value && _.isNumber(+value);
    let isDate = false;

    switch (name) {
      case 'startDate': {
        isDate = true;
        this.props.updateStartDate(moment(value));
        break;
      }
      case 'endDate': {
        isDate = true;
        this.props.updateEndDate(moment(value));
        break;
      }

      case 'trials': {
        if (value < 0) {
          this.props.handleError(`Trials value should be a positive number`);
          return false;
        }
        if (value > 1000000) {
          this.props.handleError(`Trials value should be less than 1,000,000`);
          return false;
        }
        if (isNumber) {
          this.props.updateTrials(value);
        }
        break;
      }
    }

    if (isDate || isNumber) {
      this.props.saveConfig();
    }
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({
      [e.target.name]: value,
    });
    this.saveChanges(e.target.name, e.target.value);
  };

  render() {
    return (
      <div className='delivery-control'>
        <DateRangePicker id="startDate"
          locale={{ format: this.props.dateFormat }}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          singleDatePicker
          onApply={(e, picker) =>
            this.handleChange({
              target: { name: 'startDate', value: picker.startDate },
            })
          }
        >
          <div className='date-range-picker'>
            <label>Start date</label>
            <div className='form-control'>
              {moment(this.state.startDate).format(this.props.dateFormat)}
            </div>          
          </div>
        </DateRangePicker>
        
        <DateRangePicker
          locale={{ format: this.props.dateFormat }}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          singleDatePicker
          onApply={(e, picker) =>
            this.handleChange({
              target: { name: 'endDate', value: picker.endDate },
            })
          }
        >
          <div className='date-range-picker'>
            <label>End date</label>
            <div className='form-control'>
              {moment(this.state.endDate).format(this.props.dateFormat)}
            </div>
          </div>
        </DateRangePicker>

        <div>
          <label htmlFor="trials">Trials</label>
          <input
            name="trials"
            type="number"
            id="trials"
            placeholder="Trials"
            className='form-control'
            value={this.state.trials || 0}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleError: (err) => dispatch(handleError(err, { log: false })),
    saveConfig: () => dispatch(saveConfig()),
    updateTrials: (val) => dispatch(updateTrials(val, 'mct')),
    updateStartDate: (val) => dispatch(updateStartDate(val, 'mct', 'startDate')),
    updateEndDate: (val) => dispatch(updateEndDate(val, 'mct')),
  };
};

const mapStateToProps = (state) => {
  return {
    trials: state.filters.mct.trials,
    startDate: state.filters.mct.startDate,
    endDate: state.filters.mct.endDate,
    dateFormat: state.filters.dateFormat,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(MonteCarloTasksControls);
export { connected as MonteCarloTasksControls };
